export type FrameGroup = {
  group: string;
  opex: keyof FinancialFrameUpdate;
  capex: keyof FinancialFrameUpdate;
};

export const FRAME_GROUPS: FrameGroup[] = [
  {
    group: 'growthNewCmps',
    opex: 'growthNewCmpsOpex',
    capex: 'growthNewCmpsCapex',
  },
  {
    group: 'fulfilmentAndReplenishment',
    opex: 'fulfilmentAndReplenishmentOpex',
    capex: 'fulfilmentAndReplenishmentCapex',
  },
  {
    group: 'spaceOptimisationWith3rdParty',
    opex: 'spaceOptimisationWith3rdPartyOpex',
    capex: 'spaceOptimisationWith3rdPartyCapex',
  },
  {
    group: 'commercialAndCoworkerAreasAndConcept',
    opex: 'commercialAndCoworkerAreasAndConceptOpex',
    capex: 'commercialAndCoworkerAreasAndConceptCapex',
  },
  {
    group: 'realEstate',
    opex: 'realEstateOpex',
    capex: 'realEstateCapex',
  },
  {
    group: 'digitalTechnology',
    opex: 'digitalTechnologyOpex',
    capex: 'digitalTechnologyCapex',
  },
];

export type FinancialFrameRowType = 'COUNTRY' | 'GLOBAL' | 'UNALLOCATED';

export const SUB_PORTFOLIO_BY_GROUP: Record<string, string> = {
  growthNewCmps: 'GROWTH_NEW_CMPS',
  fulfilmentAndReplenishment: 'FULFILMENT_AND_REPLENISHMENT',
  spaceOptimisationWith3rdParty: 'SPACE_OPTIMISATION_WITH_3RD_PARTY',
  commercialAndCoworkerAreasAndConcept:
    'COMMERCIAL_AND_COWORKER_AREAS_AND_CONCEPT',
  realEstate: 'REAL_ESTATE',
  digitalTechnology: 'DIGITAL_TECHNOLOGY',
};

export type FinancialFrame = {
  id: number | null;
  rowType?: FinancialFrameRowType;
  countryId: string;
  countryName: string;
  fiscalYear: string;
  growthNewCmpsOpex: number;
  growthNewCmpsCapex: number;
  countryPAndLOpex: number;
  countryPAndLCapex: number;
  fulfilmentAndReplenishmentOpex: number;
  fulfilmentAndReplenishmentCapex: number;
  centresPortfolioOpex: number;
  centresPortfolioCapex: number;
  propertyExitsOpex: number;
  propertyExitsCapex: number;
  commercialAndCoworkerAreasAndConceptOpex: number;
  commercialAndCoworkerAreasAndConceptCapex: number;
  realEstateOpex: number;
  realEstateCapex: number;
  spaceOptimisationWith3rdPartyOpex: number;
  spaceOptimisationWith3rdPartyCapex: number;
  digitalTechnologyOpex: number;
  digitalTechnologyCapex: number;
  actualsOpex?: number | null;
  actualsCapex?: number | null;
  updatedAt: string;
  updatedBy: string;
};

export type FinancialFrameUpdate = {
  growthNewCmpsOpex: number;
  growthNewCmpsCapex: number;
  countryPAndLOpex: number;
  countryPAndLCapex: number;
  fulfilmentAndReplenishmentOpex: number;
  fulfilmentAndReplenishmentCapex: number;
  centresPortfolioOpex: number;
  centresPortfolioCapex: number;
  propertyExitsOpex: number;
  propertyExitsCapex: number;
  commercialAndCoworkerAreasAndConceptOpex: number;
  commercialAndCoworkerAreasAndConceptCapex: number;
  realEstateOpex: number;
  realEstateCapex: number;
  spaceOptimisationWith3rdPartyOpex: number;
  spaceOptimisationWith3rdPartyCapex: number;
  digitalTechnologyOpex: number;
  digitalTechnologyCapex: number;
};

export type Amount = {
  local: number;
  eur: number;
};

export type OpexCapexAmounts = {
  opex: Amount;
  capex: Amount;
  total: Amount;
};

export type GlobalForecastLatestAdjustment = {
  month: number;
  fiscalYear: string;
  opex: number | null;
  capex: number | null;
  reportedOpex: number | null;
  reportedCapex: number | null;
  comment: string;
  updatedAt: string;
  updatedBy: string;
};

export type GlobalForecastSubPortfolio = {
  subPortfolio: string;
  allocatedFrame: OpexCapexAmounts;
  reportedForecast: OpexCapexAmounts;
  diff: OpexCapexAmounts;
  actuals: OpexCapexAmounts;
  latestAdjustment: GlobalForecastLatestAdjustment | null;
};

export type GlobalForecast = {
  fiscalYear: string;
  currentMonth: number;
  subPortfolios: GlobalForecastSubPortfolio[];
};

export type GlobalForecastAdjustment = {
  fiscalYear: string;
  subPortfolio: string;
  opex: number | null;
  capex: number | null;
  comment: string;
};

export type FinancialFramesState = {
  loading: boolean;
  loaded: boolean;
  updateLoading: boolean;
  error: Error;
  financialFrames: FinancialFrame[];
  globalForecast: GlobalForecast | null;
  globalForecastLoading: boolean;
  globalForecastSubmitLoading: boolean;
};

export const initialState: FinancialFramesState = {
  loading: false,
  loaded: false,
  updateLoading: false,
  error: null,
  financialFrames: [],
  globalForecast: null,
  globalForecastLoading: false,
  globalForecastSubmitLoading: false,
};
